import React, { useState } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

export default function Login() {
  const { user, loginWithGoogle, loading } = useAuth();
  const [error, setError] = useState('');
  const [isRedirecting, setIsRedirecting] = useState(false);

  // Already logged in — go to app
  if (user) return <Navigate to="/app" replace />;

  async function handleGoogleLogin() {
    setError('');
    setIsRedirecting(true);
    const result = await loginWithGoogle();
    if (!result.success) {
      setError(result.error || 'Google sign-in failed. Please try again.');
      setIsRedirecting(false);
    }
    // If success, the page will redirect — no need to reset loading state
  }

  return (
    <div className="login-page">
      <div className="login-card">

        {/* Logo */}
        <div className="login-logo">
          <span className="brand-logo-text">fenscope.</span>
        </div>

        <div className="login-heading">
          <h1>Welcome back</h1>
          <p>Sign in to protect your scope and your income.</p>
        </div>

        {error && <div className="login-error">{error}</div>}

        {/* Google Sign In */}
        <button
          id="google-login-btn"
          className="login-google-btn"
          onClick={handleGoogleLogin}
          disabled={loading || isRedirecting}
          type="button"
        >
          {isRedirecting ? (
            <>
              <div className="login-spinner" />
              Redirecting to Google…
            </>
          ) : (
            <>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4" />
                <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853" />
                <path d="M3.964 10.706A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.038l3.007-2.332z" fill="#FBBC05" />
                <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.962L3.964 6.294C4.672 4.169 6.656 3.58 9 3.58z" fill="#EA4335" />
              </svg>
              Continue with Google
            </>
          )}
        </button>

        <p className="login-footer-note">
          By continuing, you agree to our{' '}
          <Link to="/terms" style={{ color: 'var(--accent)' }}>Terms of Service</Link>{' '}
          and{' '}
          <Link to="/privacy" style={{ color: 'var(--accent)' }}>Privacy Policy</Link>.
        </p>

      </div>
    </div>
  );
}
